/**
 *  Validations for various data types
 *  - Every property has to be a function that returns a boolean.
 *  - All properties should be lowercase.
 *  - parameters are value, element, data-attribute where:
 *
 *  value {String}: the value of the elements in the jQuery object.
 *  element {jQuery}: jQuery object containing 1 or more elements.
 *  data-attribute {String}: the value of the data-attribute.
 *
 *  So when this input is validated
 *  <input value='apple' data-equals='banana' />
 *
 *  equals('apple', jQuery, 'banana');
 */

define('libs/validation.validations',[],function() {

    'use strict';

    return {
        required: function(value) {
            return !!value.match(/\S+/);
        },
        email: function(value) {
            var email = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,6}$/i;
            return email.test(value);
        },
        numeric: function(value) {
            var numeric = /^-?(\d+(\.|,))?\d+$/;
            value = value.replace(/\s/g, '');
            return numeric.test(value);
        },
        equals: function(value, element, same) {
            return value == same;
        },
        zipcodenl: function(value) {
            return (/^[0-9]{4}[a-zA-Z]{2}$/).test(value.replace(/\s*/g, ''));
        },
        phonenumbernl: function(value) {
            var phone = /^(((00\s?|\+)\d{2}|0)[\s-]*((\d{2}[\s-]*\d{7})|(\d{3}[\s-]*\d{6})|(6[\s-]*\d{8})))$/;
            return phone.test(value);
        },
        minchars: function(value, element, minChars) {
            return (value.length >= minChars);
        },
        maxchars: function(value, element, maxChars) {
            return (value.length <= maxChars);
        },
        nospaces: function(value) {
            var noSpaces = /\s/;
            return !noSpaces.test(value);
        },
        minselected: function(value, elements, min) {
            var selected = 0;
            elements.each(function() {
                if (this.checked) selected++;
            });
            return (selected >= min);
        },
        maxselected: function(value, elements, max) {
            var selected = 0;
            elements.each(function() {
                if (this.checked) selected++;
            });
            return (selected <= max);
        }
    };
});

